/**
 * BLOOME — Scroll Animations & Visual Effects
 * Uses IntersectionObserver for performant scroll-triggered animations
 */

(function() {
  'use strict';

  // --- Scroll Reveal ---
  function initScrollReveal() {
    var elements = document.querySelectorAll('.bloome-reveal, .bloome-stagger, .bloome-stat-pop');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // --- Comparison rows staggered reveal ---
  function initComparisonReveal() {
    var rows = document.querySelectorAll('.bloome-comparison__row');
    if (!rows.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px'
    });

    rows.forEach(function(row, i) {
      row.style.transitionDelay = (i * 0.1) + 's';
      observer.observe(row);
    });
  }

  // --- Animated counter for stats ---
  function animateCounter(el) {
    var text = el.textContent.trim();
    var match = text.match(/^([\d.,]+)/);
    if (!match) return;

    var raw = match[1];
    var suffix = text.substring(raw.length);
    var isDecimal = raw.indexOf(',') > -1 || raw.indexOf('.') > -1;
    var target = parseFloat(raw.replace(/\./g, '').replace(',', '.'));

    if (isNaN(target) || target === 0) return;

    var duration = 1200;
    var start = performance.now();

    function step(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;

      if (isDecimal) {
        el.textContent = current.toFixed(1).replace('.', ',') + suffix;
      } else if (target >= 1000) {
        el.textContent = Math.round(current).toLocaleString('de-DE') + suffix;
      } else {
        el.textContent = Math.round(current) + suffix;
      }

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = raw + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    var statValues = document.querySelectorAll('.bloome-solution__stat-value');
    if (!statValues.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    statValues.forEach(function(el) {
      observer.observe(el);
    });
  }

  // --- Floating particles for hero & final CTA ---
  function createParticles(container, count) {
    var colors = ['#FF5F8A', '#FF8FAB', '#FFD0DC', '#E8467A', '#FF7BA0'];
    var wrapper = document.createElement('div');
    wrapper.className = 'bloome-particles';

    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'bloome-particle';
      var size = 4 + Math.random() * 8;
      var color = colors[Math.floor(Math.random() * colors.length)];
      p.style.width = size + 'px';
      p.style.height = size + 'px';
      p.style.background = color;
      p.style.left = Math.random() * 100 + '%';
      p.style.bottom = '-20px';
      p.style.animationDuration = (12 + Math.random() * 18) + 's';
      p.style.animationDelay = (Math.random() * 15) + 's';
      wrapper.appendChild(p);
    }

    container.style.position = 'relative';
    container.appendChild(wrapper);
  }

  function initParticles() {
    var hero = document.querySelector('.bloome-product-hero');
    if (hero) createParticles(hero, 12);

    var finalCta = document.querySelector('.bloome-final-cta');
    if (finalCta) createParticles(finalCta, 8);
  }

  // --- Auto-apply animation classes to sections ---
  function autoApplyClasses() {
    // Headings & labels: fade up
    var selectors = [
      '.bloome-problem__label',
      '.bloome-problem__heading',
      '.bloome-solution__label',
      '.bloome-solution__heading',
      '.bloome-solution__text',
      '.bloome-ingredients__label',
      '.bloome-ingredients__heading',
      '.bloome-how-it-works__label',
      '.bloome-how-it-works__heading',
      '.bloome-testimonials__label',
      '.bloome-testimonials__title',
      '.bloome-comparison__label',
      '.bloome-comparison__heading',
      '.bloome-faq__label',
      '.bloome-faq__heading',
      '.bloome-final-cta__heading',
      '.bloome-final-cta__text',
      '.bloome-newsletter__title',
      '.bloome-newsletter__text'
    ];

    selectors.forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el && !el.classList.contains('bloome-reveal')) {
        el.classList.add('bloome-reveal');
      }
    });

    // Solution visual: slide from left
    var solutionVisual = document.querySelector('.bloome-solution__visual');
    if (solutionVisual) {
      solutionVisual.classList.add('bloome-reveal', 'bloome-reveal--left');
    }

    // Solution content: slide from right
    var solutionContent = document.querySelector('.bloome-solution__content');
    if (solutionContent) {
      solutionContent.classList.add('bloome-reveal', 'bloome-reveal--right');
    }

    // Card grids: staggered
    var staggerGrids = [
      '.bloome-problem__grid',
      '.bloome-ingredients__grid',
      '.bloome-how-it-works__steps',
      '.bloome-testimonials__grid'
    ];

    staggerGrids.forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el) {
        el.classList.add('bloome-stagger');
      }
    });

    // Stat values: pop
    document.querySelectorAll('.bloome-solution__stat').forEach(function(el) {
      el.classList.add('bloome-stat-pop');
    });

    // CTA buttons: glow
    document.querySelectorAll('.bloome-product-hero__cta, .bloome-final-cta__button').forEach(function(el) {
      el.classList.add('bloome-glow');
    });

    // Comparison table: scale reveal
    var compTable = document.querySelector('.bloome-comparison__table');
    if (compTable) {
      compTable.classList.add('bloome-reveal', 'bloome-reveal--scale');
    }

    // FAQ list: stagger
    var faqList = document.querySelector('.bloome-faq__list');
    if (faqList) {
      faqList.classList.add('bloome-stagger');
    }

    // Newsletter form: reveal
    var nlForm = document.querySelector('.bloome-newsletter__form');
    if (nlForm) {
      nlForm.classList.add('bloome-reveal');
    }
  }

  // --- Parallax on hero orbs (CSS pseudo-elements can't be controlled, so we add extra divs) ---
  function initHeroParallax() {
    var hero = document.querySelector('.bloome-product-hero');
    if (!hero) return;

    window.addEventListener('scroll', function() {
      var scrolled = window.pageYOffset;
      var rate = scrolled * 0.3;
      if (scrolled < window.innerHeight) {
        hero.style.setProperty('--parallax-y', rate + 'px');
      }
    }, { passive: true });
  }

  // --- Init all ---
  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    autoApplyClasses();
    initScrollReveal();
    initComparisonReveal();
    initCounters();
    initParticles();
    initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
